<div class="wrap">
  <app-ask-licence *ngIf="!linkYourAccount" [@ask]></app-ask-licence>
  <app-check-licence *ngIf="linkYourAccount" [@linkYourAccount]></app-check-licence>
</div>
